/**
 * @fileoverview PUT handler for the "/comments/:target/notification_setting" endpoint
 */
import fetch from "@lib/fetch";

import type { AppendAppGroupToUrl } from "../comments/types";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { commentsTargetNotificationSettingCacheKeys } from "./constants";
import type { PutCommentsTargetNotificationSettingProps } from "./types";

export const putCommentsNotificationSetting = reactQueryMutationAdapter(
  commentsTargetNotificationSettingCacheKeys,
  ({
    target,
    explicit_setting,
    appGroupId,
  }: AppendAppGroupToUrl<PutCommentsTargetNotificationSettingProps>): Promise<{}> => {
    return fetch(`/comments/${target}/notification_setting?app_group_id=${appGroupId}`, "PUT", {
      explicit_setting,
    });
  }
);
